<template>
  <el-dialog  :visible.sync="dialogVisible" class="w-100" top="40px">
    <div class="menu-button">
      <el-button type="primary" size="mini" @click="deleteAll">全部删除</el-button>
      &nbsp;
      <el-upload ref="upload" class="upload-button" :multiple="false" :limit="1"
                 action=""
                 :auto-upload=true
                 :accept="accept"
                 :show-file-list=false
                 :before-upload="handleBeforeUpload"
                 :headers="headers"
                 :http-request="dpBatchImportInsured"
                 :on-progress="handleUploading"
                 :on-success="handleUploadSuccess"
                 :on-error="handleUploadError">
        <el-button slot="trigger" size="mini"
                   type="primary">批量导入</el-button>
      </el-upload>
    </div>
    <table class="insured_table">
      <tr>
        <th>船名</th>
        <th>被保险人</th>
        <th>保费</th>
        <th>推荐人</th>
        <th>业务区域</th>
        <th>业务来源</th>
        <th>托管代理人</th>
        <th>船龄</th>
        <th>船籍港</th>
        <th>船舶种类</th>
        <th>总吨</th>
        <th>载重吨</th>
        <th>航行区域</th>
      </tr>
      <tr v-for="(insured, i) in insured_contents" :key="i" >
        <td>{{insured.ship_name}}</td>
        <td>{{insured.insured}}</td>
        <td>{{insured.premium}}</td>
        <td>{{insured.referrer}}</td>
        <td>{{insured.business_area}}</td>
        <td>{{insured.business_source}}</td>
        <td>{{insured.escrow_agent}}</td>
        <td>{{insured.ship_age}}</td>
        <td>{{insured.port_of_registry}}</td>
        <td>{{insured.ship_type}}</td>
        <td>{{insured.total_tons}}</td>
        <td>{{insured.dwt}}</td>
        <td>{{insured.sailing_area}}</td>
      </tr>
    </table>
  </el-dialog>
</template>

<script>
import { batchImportInsured } from '@/api/insured'
import {getToken} from "@/utils/auth"
import {importPolicyTableFile} from "@/api/upload";
export default {
  name: "insured-info-table",
  props:{
    insureds: {default: function() {return []}}
  },
  data(){
    return {
      dialogVisible: false,
      // accept: '.xlsx,.xls',
      accept: '',
      insured_info:{
        insureds: {}
      },
      insured_contents:[],
    }
  },
  methods:{
    showDialog(){
      this.dialogVisible = true
    },
    deleteAll(){
      this.insured_contents = []
      this.$emit('change', this.insured_contents)
    },
    handleBeforeUpload() {

    },
    handleUploading(){

    },
    handleUploadSuccess(resp){
      if (resp.result === 0){
        this.$message.success('导入成功')
        this.insured_contents = resp.insureds
        this.$emit('change', this.insured_contents)
        return
      }
      this.$message.error(resp.msg)
    },
    handleUploadError(resp){
      this.$message.error(resp)
    },
    dpBatchImportInsured(param){
      let fileObj = param.file
      let fd = new FormData()
      fd.append('file', fileObj)
      batchImportInsured(fd)
          .then(resp => {
            param.onSuccess(resp)
            this.$refs.upload.clearFiles()
          })
          .catch(error => {
            param.onError(error)
            this.$refs.upload.clearFiles()
          })
    }
  },
  watch: {
    'insureds': function(val){
      this.insured_contents = val
    },
  },
  computed: {
    headers() {
      return {'Authorization': 'Token ' + getToken()}
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  width:96%
}
.insured_table {
  width: 100%;
}
.menu-button {
  float: right;
}
.upload-button {
  display: inline;
}
</style>
